import React, { useState, useLayoutEffect, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Iconify from "../../../layouts/components/iconify/iconify";

const RenderTabs = ({ tabs }) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const tabRefs = useRef([]);
  const indicatorRef = useRef(null);

  const updateIndicator = () => {
    const activeTabElement = tabRefs.current[activeTab];
    const indicator = indicatorRef.current;

    if (activeTabElement && indicator) {
      indicator.style.width = `${activeTabElement.offsetWidth}px`;
      indicator.style.left = `${activeTabElement.offsetLeft}px`;
    }
  };

  useEffect(() => {
    const activeTabElement = tabRefs.current[activeTab];
    if (activeTabElement) {
      const resizeObserver = new ResizeObserver(() => {
        updateIndicator();
      });

      resizeObserver.observe(activeTabElement);

      return () => resizeObserver.disconnect();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  useLayoutEffect(() => {
    updateIndicator();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, tabs]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      updateIndicator();
    }, 0);

    return () => clearTimeout(timeoutId);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTabClick = (tabIndex, navigationPath) => {
    setActiveTab(tabIndex);
    if (navigationPath) {
      navigate(navigationPath);
    }
  };

  return (
    <>
      {tabs && tabs.length > 0 && (
        <div className="row">
          <div className="col-12">
            <div className="tab-section mb-0">
              <div className="tab-header">
                {tabs.map((tab, index) => (
                  <div key={index} className="tab-button">
                    <button
                      className={activeTab === index ? "active" : ""}
                      onClick={() => handleTabClick(index, tab.sPage)}
                      ref={(el) => (tabRefs.current[index] = el)}
                    >
                      <Iconify icon={tab.icon} />
                      <div style={{paddingTop: "2px"}}>{tab.sMenuItemCaption}</div>
                    </button>
                  </div>
                ))}
                <div className="tab-indicator" ref={indicatorRef}></div>
              </div>
              {activeTab !== -1 && tabs[activeTab].component && (
                <div className="tab-content">
                  <div className="tab-body-section">
                    {tabs[activeTab].component}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RenderTabs;
